var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Design Convert",
    id: "Design_Convert",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:000; stroke: #010101;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,57H17a5,5,0,0,1-5-5V37H10.76a3.63,3.63,0,0,1-3.29-2.36,5.27,5.27,0,0,1,.76-5.59L25.29,10.12a8.78,8.78,0,0,1,13.42,0L55.77,29.05h0a5.27,5.27,0,0,1,.76,5.59A3.63,3.63,0,0,1,53.24,37H52V52A5,5,0,0,1,47,57ZM32,9a7,7,0,0,0-5.23,2.46L9.71,30.39a3.35,3.35,0,0,0-.42,3.44A1.78,1.78,0,0,0,10.76,35H13a1,1,0,0,1,1,1V52a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V36a1,1,0,0,1,1-1h2.24a1.78,1.78,0,0,0,1.47-1.17,3.35,3.35,0,0,0-.42-3.44h0L37.23,11.46A7,7,0,0,0,32,9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,57H26a1,1,0,0,1-1-1V40a7,7,0,0,1,14,0V56A1,1,0,0,1,38,57ZM27,55H37V40a5,5,0,0,0-10,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage);
export default __webpack_public_path__ + "static/media/homePage.cd6e28faf0450666c4842b0b8d5e711a.svg";
export { ForwardRef as ReactComponent };